import { render, staticRenderFns } from "./PDropDownContainer.vue?vue&type=template&id=10c44116&scoped=true"
import script from "./PDropDownContainer.vue?vue&type=script&lang=ts"
export * from "./PDropDownContainer.vue?vue&type=script&lang=ts"
import style0 from "./PDropDownContainer.vue?vue&type=style&index=0&id=10c44116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c44116",
  null
  
)

export default component.exports